import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { INTEGRATION_TYPES } from "../../utils/app-constants.json";
import { RULE_KEYS } from "../../utils/rules";
import pagerDutySpec from "./integrations-specs/pagerduty.json";
import teamsSpec from "./integrations-specs/teams.json";
import jiraSpec from "./integrations-specs/jira.json";
import slackSpec from "./integrations-specs/slack.json";
import snsSpec from "./integrations-specs/sns.json";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

export const allIntegrations = () => {
  return [
    {
      Name: "Jira",
      Description: "Send DAY2™ alerts to Jira and analyze the issue",
      ConnectedChannels: 0,
      Service: INTEGRATION_TYPES.JIRA_ISSUE,
      Category: `integration.${INTEGRATION_TYPES.JIRA_ISSUE}`,
      Action: {
        ActionName: "Create Ticket",
        ActionType: RULE_KEYS.DAY2_TICKET_ACTION,
      },
    },
    {
      Name: "Slack",
      Description: "Send DAY2™ alerts to a designated Slack channel",
      ConnectedChannels: 5,
      Service: INTEGRATION_TYPES.SLACK,
      Category: `integration.${INTEGRATION_TYPES.SLACK}`,
      Action: {
        ActionName: "Send Notification",
        ActionType: RULE_KEYS.DAY2_NOTIFICATION_ACTION,
      },
    },
    {
      Name: "Microsoft Teams",
      Description: "Send DAY2™ alerts to a designated Microsoft Teams channel",
      ConnectedChannels: 2,
      Service: INTEGRATION_TYPES.MICROSOFT_TEAMS,
      Category: `integration.${INTEGRATION_TYPES.MICROSOFT_TEAMS}`,
      Action: {
        ActionName: "Send Notification",
        ActionType: RULE_KEYS.DAY2_NOTIFICATION_ACTION,
      },
    },
    {
      Name: "PagerDuty",
      Description: "Send DAY2™ alerts to PagerDuty and begin an investigation",
      ConnectedChannels: 1,
      Service: INTEGRATION_TYPES.PAGERDUTY,
      Category: `integration.${INTEGRATION_TYPES.PAGERDUTY}`,
      Action: {
        ActionName: "Create Ticket",
        ActionType: RULE_KEYS.DAY2_TICKET_ACTION,
      },
    },
    {
      Name: "SNS",
      Description: "Send pragmatic alerts to emails with DAY2™ via SNS",
      ConnectedChannels: 2,
      Service: INTEGRATION_TYPES.SNS,
      Category: `integration.${INTEGRATION_TYPES.SNS}`,
      Action: {
        ActionName: "Send Notification",
        ActionType: RULE_KEYS.DAY2_NOTIFICATION_ACTION,
      },
    },
    {
      Name: "SQS",
      Description: "Send pragmatic notifications to emails with DAY2™ via SQS",
      ConnectedChannels: 0,
      Service: INTEGRATION_TYPES.SQS,
      Category: `integration.${INTEGRATION_TYPES.SQS}`,
      Action: {
        ActionName: "Send Notification",
        ActionType: RULE_KEYS.DAY2_NOTIFICATION_ACTION,
      },
    },
  ];
};

export const getIntegrationSpec = async (type) => {
  switch (type) {
    case INTEGRATION_TYPES.JIRA_ISSUE:
      return jiraSpec;
    case INTEGRATION_TYPES.PAGERDUTY_INCIDENT:
      return pagerDutySpec;
    case INTEGRATION_TYPES.MICROSOFT_TEAMS:
      return teamsSpec;
    case INTEGRATION_TYPES.SLACK:
      return slackSpec;
    case INTEGRATION_TYPES.SNS:
      return snsSpec;
    default:
      return {};
  }
};

export const allIntegrationsItems = async (type) => {
  let integrations = defaultValuesOld().allIntegrations[type];
  let accounts = await getAccounts();
  let host = "";
  return integrations.map((integration, index) => {
    const item = {
      IntegrationId: `destination-${index}`,
      Message: `${integration.Description} channel`,
      Description: integration.Description,
      ChannelName: integration.ChannelName,
    };
    if (type === INTEGRATION_TYPES.SLACK) {
      host = "https://hooks.slack.com/services/";
    }
    if (type === INTEGRATION_TYPES.MICROSOFT_TEAMS) {
      host = "https://montycloud.webhook.office.com/";
    }
    if (type === INTEGRATION_TYPES.SNS) {
      const accountNumber = faker.helpers.arrayElement(accounts);
      item["AccountNumber"] = accountNumber;
      item["TopicArn"] = `arn:aws:sns:${faker.helpers.arrayElement(
        regionCodes
      )}:${accountNumber}:MC-Test-Topic`;
    }
    if (host) {
      item.WebhookURL = `${host}${faker.number.int({ min: 10000 })}`;
    }

    return {
      IntegrationId: item.IntegrationId,
      Data: {
        ...item,
        Name: item.ChannelName,
      },
    };
  });
};
